import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useBottomOffset } from './useBottomOffset';
export const useMarginBottom = (key = 'marginBottom', offset = 0, ...extraStyles) => {
    const { bottom } = useSafeAreaInsets();
    const bottomOffset = useBottomOffset();
    const style = useMemo(() => ({
        [key]: bottomOffset + offset,
        ...StyleSheet.flatten(extraStyles),
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bottom, extraStyles[0], extraStyles[1], extraStyles[2], key, offset]);
    return style;
};
